import type { Localite } from '~/api/gen'

// Communes couvrant les annonces mock de frontend/msw/mocks/diffusion/annoncesDiffusion.ts,
// pour que la sélection d'une localité dans la sidebar filtre le bon jeu de données en e2e.
export const localites: Localite[] = [
  { nom: 'Toulouse', codePostal: '31000' },
  { nom: 'Bordeaux', codePostal: '33000' },
  { nom: 'Nantes', codePostal: '44000' },
  { nom: 'Rennes', codePostal: '35000' },
  { nom: 'Lyon', codePostal: '69001' },
]
